import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CostMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.cost.costMapperError"));

        Object.setPrototypeOf(this, CostMapperError.prototype);
    }
}